import { JSX } from 'solid-js';

interface NavbarActionProps {
  icon: string;
  disabled?: boolean;
  onClick?(): void;
}

export const NavbarAction = (props: NavbarActionProps): JSX.Element => (
  <div
    class={`w-8 h-8 flex items-center justify-center ${
      props.disabled ? 'opacity-25' : 'cursor-pointer hover:bg-gray-0 rounded'
    }`}
    onClick={() => !props.disabled && props.onClick?.()}
    data-testid={`${props.icon}_action`}
  >
    <i class={`icon-font ${props.icon}`} />
  </div>
);
